module.exports = __webpack_public_path__ + "img/future_web.18382683.svg";